export default "__VITE_ASSET__CLTaAYz9__"